export const decodeHtml = (html) => {
    if (!html || typeof html !== 'string') return html;
    return html.replace(/&amp;/g, '&');
};

export const parsePrice = (value) => {
    if (typeof value === 'number') return value;
    if (!value) return null;
    const parsed = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    return Number.isFinite(parsed) ? parsed : null;
};

// Words that should stay UPPERCASE in company names
const ALWAYS_UPPER = new Set([
    '3M', 'GSK', 'MSD', 'AZ', 'API', 'USA', 'UK', 'INC', 'LLC', 'LLP',
    'HLL', 'MSN', 'FDC', 'RPG', 'USV', 'JB', 'ZIM', 'GVK', 'PCD', 'OTC',
    'AARTI', 'IDBI', 'SBI', 'HDFC', 'ICICI',
]);
// Words that should be title-cased normally
const ALWAYS_TITLE = new Set([
    'Ltd', 'Pvt', 'Co', 'And', 'Of', 'The', 'India', 'Pharma', 'Pharmaaceuticals',
    'Laboratories', 'Healthcare', 'Remedies', 'Biotech', 'Lifesciences', 'Lifescience',
]);
// Common lowercase suffix words
const ALWAYS_LOWER = new Set(['and', 'of', 'the', 'a', 'an', 'de', 'van']);

export const formatCompanyName = (name) => {
    if (!name || typeof name !== 'string') return name;
    const trimmed = name.trim();
    if (!trimmed) return trimmed;

    return trimmed
        .split(/\s+/)
        .map((word, idx) => {
            // Strip punctuation for comparison but preserve it in output
            const clean = word.replace(/[^A-Za-z0-9]/g, '').toUpperCase();

            // Always-uppercase acronyms / short codes
            if (ALWAYS_UPPER.has(clean)) return word.toUpperCase();

            // Numbers + letters like 3M, L&T — keep as-is if mixed
            if (/^[0-9]/.test(word)) return word;

            // Common lowercase connectors (not at start)
            if (idx > 0 && ALWAYS_LOWER.has(word.toLowerCase())) return word.toLowerCase();

            // Standard title case: capitalize first letter, lowercase rest
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
};

export const formatPackingInfo = (pack, unit, category, productName) => {
    let p = (pack || '').trim();
    let u = (unit || '').trim();
    
    if (!p && !u) return '';
    if (!p) return u;
    if (!u) return p;
    
    // If pack and unit are the same (e.g., both "100 GM"), just return one
    if (p.toLowerCase() === u.toLowerCase()) return p;

    // Check if `pack` is just numbers (e.g. "1" or "10")
    const isPackNumeric = /^\d+$/.test(p);
    
    if (isPackNumeric) {
        let container = 'pack'; // default
        const lower = ((productName || '') + ' ' + (category || '')).toLowerCase();
        
        if (lower.includes('syrup') || lower.includes('susp') || lower.includes('liquid') || lower.includes('drop')) {
            container = 'bottle';
        } else if (lower.includes('tab') || lower.includes('cap') || lower.includes('pill')) {
            container = 'strip';
        } else if (lower.includes('inj') || lower.includes('vial') || lower.includes('vaccine')) {
            container = 'vial';
        } else if (lower.includes('cream') || lower.includes('gel') || lower.includes('oint') || lower.includes('paste')) {
            container = 'tube';
        } else if (lower.includes('powder') || lower.includes('sachet') || lower.includes('granules')) {
            container = 'packet';
        }
        
        // Add "s" for plural
        if (parseInt(p) > 1) {
            container += 's';
        }
        
        return `${p} ${container} of ${u}`;
    }
    
    // If pack already has words
    if (p.toLowerCase().includes(' in ')) {
        return p;
    }
    return `${p} of ${u}`;
};
